"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { ChevronLeft, ShoppingBag } from "lucide-react";

import { NotificationBell } from "@/components/NotificationBell";
import { useCart } from "@/lib/cart";
import { canGoBackInApp, isPlainClick } from "@/lib/historyNav";

const HEADER_GRADIENT = "bg-gradient-to-r from-shopeeDark via-shopee to-shopeeLight";

/**
 * Header halaman `/bundling` & `/bundling/[slug]` — bentuk yang sama dengan header
 * `/promo` (gradien tema, lonceng, keranjang ber-badge). Badge keranjang
 * memakai `totalQty` yang sudah menghitung pcs bundel.
 */
export function BundleHeader({ title, backHref }: { title: string; backHref: string }) {
  const { totalQty } = useCart();
  const router = useRouter();
  return (
    <header className={`sticky top-0 z-30 ${HEADER_GRADIENT} px-3 py-3 safe-top`}>
      <div className="flex items-center gap-2.5">
        <Link
          href={backHref}
          aria-label="Kembali"
          // Kembali ke entri riwayat sebelumnya bila milik situs ini (idiom
          // halaman produk); tautan yang dibuka dari WA tetap ke `backHref`.
          onClick={(event) => {
            if (!isPlainClick(event) || !canGoBackInApp()) return;
            event.preventDefault();
            router.back();
          }}
          className="grid h-10 w-10 shrink-0 place-items-center rounded-lg text-white"
        >
          <ChevronLeft size={24} />
        </Link>
        <h1 className="min-w-0 flex-1 truncate text-base font-extrabold text-white">{title}</h1>
        <div className="flex shrink-0 items-center">
          <NotificationBell variant="bar" />
          <Link
            href="/keranjang"
            aria-label="Keranjang"
            className="relative grid h-10 w-10 shrink-0 place-items-center text-white"
          >
            <ShoppingBag size={24} />
            {totalQty > 0 ? (
              <span className="absolute right-0 top-0 grid h-4 min-w-4 place-items-center rounded-full border border-shopee bg-white px-1 text-[9px] font-bold leading-none text-shopee">
                {totalQty}
              </span>
            ) : null}
          </Link>
        </div>
      </div>
    </header>
  );
}
